<template>

  <div class="container">
    <Navigation />

    <canvas id="demo1" resize=""></canvas>
    <div id="test-font">{{text}}</div>
    <b-input v-model="text" maxlength="200" type="textarea"></b-input>
    <pre id="log"></pre>
  </div>

</template>

<script>

import Navigation from '@/components/Navigation'
import SimplexNoise from 'simplex-noise'
import paper from 'paper'

// TODO move to utils.js
const log = function(msg) {
  let data = JSON.stringify(arguments)
  document.getElementById('log').innerText += data + '\n'
}

const simplex = new SimplexNoise()

// helper functions
const N = 100
const R = (m) => Math.round(Math.random()*m)

// random direction
const RD = (r) => {
  let a = Math.random(), b = Math.random()

  if (b < a) {
    [a, b] = [b, a]
  }

  return new Point(b*r*Math.cos(2*Math.PI*a/b), b*r*Math.sin(2*Math.PI*a/b))
}

// end helpers

import SplitFiller from '@/doodles/splitfiller'
import Subtitles from '@/doodles/subtitles'
import FontFactory from '@/utils/fontfactory'
import _ from 'lodash'

class RectoGOD {
  constructor() {
    this.colorTransparent = new Color('#ffffff')
    this.colorFill = new Color('#9b0000')
    this.borderPadSize = 10
  }

  rectangle(opts) {
      let o = {
      size: opts.size || this.borderPadSize,
      strokeWidth: opts.strokeWidth || this.borderPadSize,
      strokeColor: opts.strokeColor || this.colorFill,
      fillColor: opts.fillColor || this.colorTransparent
    }

    // top-left or center for positioning
    if (opts.point) {
      o.point = opts.point
    } else {
      p.position = opts.position
    }

    let r = Path.Rectangle(o)

    return r
  }

  // two rectangles, rotated 45deg, only border
  // returns position of last rectangle
  drawDouble(p, sz) {
    let g = new Group()
    // border
    let r = Path.Rectangle({
      position: p,
      size: sz,
      strokeWidth: this.borderPadSize,
      strokeColor: this.colorFill,
      fillColor: this.colorTransparent
    })

    r.rotate(45)

    g.addChild(r)

    p.y += sz.height * .6

    // rectangle for padding, empty space
    let r2 = Path.Rectangle({
      position: p,
      size: sz,
      strokeWidth: this.borderPadSize,
      strokeColor: this.colorTransparent, //colorTransparent,
      fillColor: this.colorTransparent // colorFill
    })

    r2.rotate(45)

    g.addChild(r2)

    let r3 = r2.clone()

    p.y += this.borderPadSize
    r3.fillColor = this.colorTransparent
    r3.strokeColor = this.colorFill
    r3.position = p

    g.addChild(r3)

    return g
  }

  circle(position, radius=50) {
    let opts = {}
    if (position.position != undefined) {
      opts = position
    } else {
      opts.position = position
      opts.radius = radius
    }

    let t = new Path.Circle({
      center: opts.position,
      radius: opts.radius
    })

    t.fillColor = opts.fillColor || this.colorTransparent
    t.strokeColor = opts.strokeColor || this.colorFill
    t.strokeWidth = opts.strokeWidth || this.borderPadSize

    // set if we want it to be filled
    if (opts.filled) {
      t.fillColor = opts.fillColor || this.colorFill
    }

    return t
  }

  // draw a triangle
  triGOD(position, radius=50) {
    let opts = {}
    if (position.position != undefined) {
      opts = position
    } else {
      opts.position = position
      opts.radius = radius
    }

    let t = new Path.RegularPolygon(opts.position, 3, opts.radius)

    t.fillColor = opts.fillColor || this.colorTransparent
    t.strokeColor = opts.strokeColor || this.colorFill
    t.strokeWidth = opts.strokeWidth || this.borderPadSize

    // set if we want it to be filled
    if (opts.filled) {
      t.fillColor = opts.fillColor || this.colorFill
    }

    return t
  }

  // 0 ====== pattern
  sym0(position) {
    let radius = 10,
        filled = true

    let x0 = this.circle({position, radius, filled})

    // point is easier with rectangles
    let point = position,
        size = new Size(200, 5)

    point.x += 50

    let x1 = this.rectangle({point, size, filled})

    let g = new Group({children: [x0, x1]})
    return g
  }
}

class SymText {
  constructor(position) {
    this.position = position
  }

  draw(content) {
    let rect = new Path.Rectangle({
      position: this.position,
      size: new Size(view.bounds.width, 80),
      fillColor: '#fafafa',
      insert: false})

    /* good fonts:
     Highschool_Runes
     ransom/GotHeroin
     typewriter/ImpactLabel
     */
    let rndFont = _.sample(FontFactory.getFonts())
    let text = new PointText(this.position)
    text.fontFamily = this.fontFamily || rndFont
    text.fillColor = this.fillColor || '#222'
    text.fontSize = this.fontSize || 40
    text.content = content
    //text.fitBounds(rect.bounds)
    //text.position = path.position
  }
}

function Fontastic() {
  let tt = new SymText(new Point(100, 100))
  tt.fontFamily = 'Opattfram01'//'Wwdesigns'
  tt.fontSize = 30
  tt.draw(' <             <             <')
  tt.position.y += 30
  tt.draw('(|S///////////P:P///////////S|)')
  tt.position.y += 30
  tt.draw(' s             >             s')
  tt.position.y += 30
  tt.draw(' \\                           \\')
  tt.position.y += 30
  tt.draw('(;/////////////S/////////////;)')
  tt.position.y += 30
  tt.draw(' >                           >')

  /*tt.draw('abcdefghijklm')

  tt.position.y += 50
  tt.draw('nopqrstuvwxyz')

  tt.position.y += 50
  tt.draw('ABCDEFGHIJKLM')

  tt.position.y += 50
  tt.draw('NOPQRSTUVWXYZ')*/
}

function RectoGODs() {
  log(view.center)
  let p = view.center.clone()
  let sz = new Size(250, 250)

  p.y = 250

  let r = new RectoGOD()
  let ggdd = r.drawDouble(p, sz)

  p.x += 200
  r.triGOD(p, 50)
  p.x -= 200*2
  r.triGOD(p, 50)

  p.x += 200
  let t = r.triGOD(p, 80)
  t.rotate(180)

  r.triGOD({position: p, radius: 100})

  let p2 = _.clone(p)
  p2.y -= 250
  r.circle({position: p2, radius: 30, filled: true})
  r.circle({position: p, radius: 20})

  // triangeles at the bottom
  p.y += 200
  r.triGOD(p, 10)
  for (let i = 0; i < 15; i++) {
    let pd = _.clone(p)
    pd.x += 30 * (i+1)
    r.triGOD(pd, 10)

    pd = _.clone(p)
    pd.x -= 30 * (i+1)
    r.triGOD(pd, 10)
  }

  // 0 ==== on the sides
  let sideBurn = new Group()
  let sym = r.sym0(new Point(60, 50))
  sym.scale(.5)
  sideBurn.addChild(sym)
  for (let i = 1; i < 14; i++) {
    let s2 = sym.clone()
    s2.translate([0, 40*i])
    sideBurn.addChild(s2)
  }

  let sideBurn2 = sideBurn.clone()
  sideBurn2.rotate(180)
  sideBurn.translate([790, 0])

  //sym.position.y += 200
  /*
  let sym2 = sym.clone()
  sym2.position.y += 200*/
}

export default {
  name: 'Demos',
  components: {
    Navigation
  },
  data() {
    return {
      text: '//P:P//'
    }
  },
  methods: {
    warning(message) {
      this.$buefy.snackbar.open({
        message,
        type: 'is-warning',
        position: 'is-top',
        actionText: 'OK!',
        indefinite: false
      })
    }
  },
  created() {
    let pFonts = new FontFactory()

    window.onload = () => {
      pFonts.cleanup()

      let canvas = document.getElementById('demo1')

      // init paper.js
      paper.install(window)
      paper.setup(canvas)

      let draw = () => {
        //SplitFiller()
        //Subtitles()
        //Subtitles()
        //RectoGODs()
        Fontastic()
      }

      draw()

      let tool = new Tool()
      tool.onMouseDown = (e) => {
        paper.project.activeLayer.removeChildren()
        draw()
      }
    }
  }
}

</script>

<style>
/*
@font-face {
  font-family: Alpmagi;
  src: url(/fonts/Alpmagi.ttf);
}
*/

#demo1 {
  width: 100%;
  height: 600px;
  margin: 0 auto;
  display: block;
  cursor: pointer;
}

body {
  margin: 0;
  padding: 0;
  background-color: #fff !important;
}

#test-font {
  font-family: 'Opattfram01';
  font-size: 32px;
  line-height: 32px;
  border: 1px solid #e4e4e4;
  margin: 10px 0;
  padding: 20px;
  white-space: pre;
}

.dg .cr.number {
  border-radius: 0;
  display: block;
  margin-right: 0;
}
</style>
